import boardActions from '../actions/boardActions';

const boardReducer = (state = {}, action) => {
  switch (action.type) {
    case boardActions.constants.set:
      return action.payload;

    default:
      return state;
  }
};

export default boardReducer;
